<!-- ORGANISM: DrawerSection.vue -->
<!-- Navigation drawer section — optional subheader title followed by a list of drawer items. -->

<script setup lang="ts">
//
// Imports
//
import DrawerItem from "../molecules/DrawerItem.vue";
import type { DrawerItemType } from "../../../../types/components/common/navigation-drawer";

//
// Props & Emits
//
defineProps<{
  title?: string;
  items: readonly DrawerItemType[];
}>();
</script>

<template>
  <v-list density="compact" nav>
    <!-- Section Title -->
    <v-list-subheader v-if="title" class="text-uppercase text-caption text-medium-emphasis">
      {{ title }}
    </v-list-subheader>

    <!-- Drawer Items -->
    <DrawerItem v-for="item in items" :key="item.title" v-bind="item" />
  </v-list>
</template>
